module.exports = __webpack_public_path__ + "static/wbhoy-c59ab106983841d3efc7e495095c6d5d.jpg";